import type { SupabaseClient } from "@supabase/supabase-js";
import type { UserRoleProfile } from "~/composables/useUserRole";
import { getSupabaseAuthHeaders } from "~/composables/useSupabaseAuthHeaders";

/** Load the signed-in user's profile via server (bypasses RLS id/user_id mismatch). */
export async function fetchAuthProfileFromApi(
  supabase: SupabaseClient,
): Promise<UserRoleProfile | null> {
  try {
    const headers = await getSupabaseAuthHeaders(supabase);
    if (!headers.Authorization) return null;

    const { profile } = await $fetch<{ profile: UserRoleProfile }>(
      "/api/me/profile",
      { headers },
    );
    return profile ?? null;
  } catch (e: unknown) {
    console.warn(
      "[fetchAuthProfileFromApi]",
      e instanceof Error ? e.message : "failed",
    );
    return null;
  }
}
